
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insureshield",
      function () {
        return require("private-next-pages/insureshield/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insureshield"])
      });
    }
  